import * as tslib_1 from "tslib";
import getSharingInformation from '../actions/getSharingInformation';
import datapoints from '../datapoints';
import getAllSharePointLinks from '../utils/getAllSharePointLinks';
import handleBeforePasteEvent from '../utils/handleBeforePasteEvent';
import handleGetSharingInfoResponse from '../utils/handleGetSharingInfoResponse';
import isLinkRemovalRelatedEvent from '../utils/isLinkRemovalRelatedEvent';
import isSharePointLink from '../utils/isSharePointLink';
import processContentChangedFromSetContent from '../utils/processContentChangedFromSetContent';
import trySetIdAndClassName from '../utils/trySetIdAndClassName';
import { logUsage } from 'owa-analytics';
import getPackageBaseUrl from 'owa-session-store/lib/actions/getPackageBaseUrl';
import { trace } from 'owa-trace';
import removeComposeOnlyContent, { COMPOSE_ONLY_ATTACHMENT_CONTENT_END, COMPOSE_ONLY_ATTACHMENT_CONTENT_START, } from '../utils/removeComposeOnlyContent';
var attachmentStyles = require('../components/Attachment.scss');
function displaySpinner(anchorElement) {
    var spinnerContainer = document.createElement('img');
    spinnerContainer.src = getPackageBaseUrl() + "resources/images/spinner_16.gif";
    spinnerContainer.className = attachmentStyles.linkSpinner;
    var newElements = [];
    newElements.push(document.createComment(COMPOSE_ONLY_ATTACHMENT_CONTENT_START));
    newElements.push(spinnerContainer);
    newElements.push(document.createComment(COMPOSE_ONLY_ATTACHMENT_CONTENT_END));
    newElements.forEach(function (newElement) {
        anchorElement.appendChild(newElement);
    });
    return newElements;
}
function removeSpinner(anchorElement, addedElements) {
    addedElements.forEach(function (element) {
        try {
            anchorElement.removeChild(element);
        }
        catch (Exception) {
            // In case user has removed the spinner
        }
    });
}
export function handleSharePointLink(attachmentPlugin, shouldReplaceLinkText, anchorElement, viewState, parentItemIdWrapper, infoBarAddHandler, infoBarRemoveHandler) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var addedElements, response, hasValidFileName;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trace.info('AttachmentPlugin.handleSharePointLink');
                    logUsage(datapoints.AttachmentComposeSPLinks.datapoint.name);
                    if (shouldReplaceLinkText) {
                        // Spinner is only needed when we will replace link text
                        addedElements = displaySpinner(anchorElement);
                        logUsage(datapoints.AttachmentComposeSPLinksShouldReplaceText.datapoint.name);
                    }
                    return [4 /*yield*/, getSharingInformation(anchorElement.href)];
                case 1:
                    response = _a.sent();
                    if (!attachmentPlugin.editor) {
                        // This plugin has been disposed. No need to do anything
                        return [2 /*return*/];
                    }
                    hasValidFileName = response && response.FileName && response.FileName.length > 0;
                    // Remove spinner and replace text when conditions are met.
                    if (shouldReplaceLinkText) {
                        removeSpinner(anchorElement, addedElements);
                        if (hasValidFileName) {
                            anchorElement.text = response.FileName;
                            logUsage(datapoints.AttachmentComposeSPLinksResponseHasValidFileName.datapoint.name);
                        }
                    }
                    handleGetSharingInfoResponse(anchorElement.id, viewState, parentItemIdWrapper, response, infoBarAddHandler, infoBarRemoveHandler);
                    return [2 /*return*/];
            }
        });
    });
}
var AttachmentPlugin = /** @class */ (function () {
    function AttachmentPlugin(viewState, parentItemIdWrapper, infoBarAddHandler, infoBarRemoveHandler) {
        var _this = this;
        this.viewState = viewState;
        this.parentItemIdWrapper = parentItemIdWrapper;
        this.infoBarAddHandler = infoBarAddHandler;
        this.infoBarRemoveHandler = infoBarRemoveHandler;
        this.name = 'Attachment';
        this.tryGetAllSPLinks = function () {
            if (!_this.pendingSPLinksTask) {
                _this.pendingSPLinksTask = setTimeout(function () {
                    _this.getAllSPLinks();
                }, 500);
            }
        };
        this.processedLinkIds = [];
    }
    AttachmentPlugin.prototype.initialize = function (editor) {
        this.editor = editor;
        this.onCutDisposer = this.editor.addDomEventHandler('cut', this.tryGetAllSPLinks);
    };
    AttachmentPlugin.prototype.onPluginEvent = function (event) {
        if (event.eventType === 8 /* BeforePaste */) {
            handleBeforePasteEvent(event, this, this.viewState, this.parentItemIdWrapper, this.infoBarAddHandler, this.infoBarRemoveHandler, this.processedLinkIds);
        }
        else if (event.eventType === 6 /* ContentChanged */) {
            var contentChangedEvent = event;
            if ((contentChangedEvent.source === "AutoLink" /* AutoLink */ ||
                contentChangedEvent.source === "CreateLink" /* CreateLink */) &&
                contentChangedEvent.data &&
                contentChangedEvent.data instanceof HTMLAnchorElement) {
                if (!isSharePointLink(contentChangedEvent.data.href)) {
                    return;
                }
                trySetIdAndClassName(contentChangedEvent.data);
                this.processedLinkIds.push(contentChangedEvent.data.id);
                handleSharePointLink(this, contentChangedEvent.source === "AutoLink" /* AutoLink */, contentChangedEvent.data, this.viewState, this.parentItemIdWrapper, this.infoBarAddHandler, this.infoBarRemoveHandler);
            }
            else {
                processContentChangedFromSetContent(event, this, this.viewState, this.parentItemIdWrapper, this.infoBarAddHandler, this.infoBarRemoveHandler, this.processedLinkIds);
            }
        }
        else if (event.eventType === 7 /* ExtractContent */) {
            var extractContentEvent = event;
            extractContentEvent.content = removeComposeOnlyContent(extractContentEvent.content);
            return;
        }
        this.processLinkRemovalRelatedEvents(event);
    };
    AttachmentPlugin.prototype.processLinkRemovalRelatedEvents = function (event) {
        if (isLinkRemovalRelatedEvent(event, this.editor)) {
            this.tryGetAllSPLinks();
        }
    };
    AttachmentPlugin.prototype.getAllSPLinks = function () {
        trace.info('processSPLinks');
        this.pendingSPLinksTask = null;
        getAllSharePointLinks(this.editor, this.viewState, this.parentItemIdWrapper, this.infoBarAddHandler, this.infoBarRemoveHandler);
    };
    AttachmentPlugin.prototype.dispose = function () {
        if (this.onCutDisposer) {
            this.onCutDisposer();
            this.onCutDisposer = null;
        }
        if (this.pendingSPLinksTask) {
            clearTimeout(this.pendingSPLinksTask);
            this.pendingSPLinksTask = null;
        }
        this.editor = null;
    };
    return AttachmentPlugin;
}());
export default AttachmentPlugin;
//# sourceMappingURL=AttachmentPlugin.js.map